import axios from 'axios';

import ApiConfig from '../config/WsApiConfig';

const instance = axios.create(ApiConfig);

export default instance;
